module.exports = __webpack_public_path__ + "static/media/draft.31f8a9bc.png";